/**
 * Consent on the sign-up form. Agreeing to the terms is required everywhere. Consent to
 * marketing email is explicit in the countries marketing lists below (an unticked checkbox
 * above the terms checkbox, sent as ticked or not) and implicit everywhere else, including
 * when the country is unknown (the statement below the terms checkbox, sent as given).
 */

/** ISO 3166-1 alpha-2: where marketing consent needs a ticked checkbox (marketing's list). */
export const EXPLICIT_OPT_IN_COUNTRIES: ReadonlySet<string> = new Set(
  [
    'at', 'be', 'bg', 'hr', 'cy', 'cz', 'dk', 'ee', 'fi', 'fr', 'de', 'gr', 'hu', 'ie', 'it', 'lv', 'lt', 'lu',
    'mt', 'nl', 'pl', 'pt', 'ro', 'sk', 'si', 'es', 'se', 'is', 'no', 'li', 'ch', 'gb', 'je', 'gg', 'im', 'gi',
    'ax', 'ad', 'mc', 'sm', 'gl', 'fo', 'al', 'me', 'mk', 'rs', 'xk', 'md', 'ua', 'by', 'ru', 'tr', 'il', 'qa',
    'jo', 'eg', 'ma', 'dz', 'tn', 'sa', 'ke', 'gh', 'za', 'tz', 'sn', 'cm', 'ao', 'mz', 'bj', 'ne', 'ga', 'bf',
    'cv', 'gn', 're', 'yt', 'ca', 'cr', 'pa', 'gp', 'mq', 'gf', 'ar', 'co', 'pe', 'cn', 'jp', 'kr', 'hk', 'tw',
    'ge', 'in', 'lk', 'vn', 'id', 'th', 'ph', 'au', 'nz',
  ].map((code) => code.toUpperCase()),
)

export const MARKETING_CONSENT_TEXT = 'I agree to receive additional marketing communication.'
export const TERMS_ERROR_TEXT = 'Please agree to Splashtop Terms of Service and Privacy Policy.'
export const TERMS_OF_SERVICE_URL = 'https://www.splashtop.com/legal/terms-of-service'
export const PRIVACY_POLICY_URL = 'https://www.splashtop.com/legal/privacy-policy'

/** Implicit unless the country is one where marketing needs the checkbox; unknown is implicit. */
export function marketingConsentIsImplicit(countryCode?: string): boolean {
  return !countryCode || !EXPLICIT_OPT_IN_COUNTRIES.has(countryCode.toUpperCase())
}
